/**
 * Application polyfills.
 * zone.js is included via angular.json polyfills array.
 */

// Required for some Firebase/Node.js compatibility in browser environment
(window as any)['global'] = window;
